module.exports = __webpack_public_path__ + "media/images/shipping-75ee16d3ef80e0c621f6cb91e655649a.svg";